module.exports = __webpack_public_path__ + "static/media/bell-beaker_spain_preview.73327e95.png";